import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const ActionTypes = Constants.ActionTypes;

const _questions = {};
let _score = 0;
let _lastQuestionId = null;
let _lastQuestionSaved = false;
let _lastQuestionSkipped = false;
let _lastActionType = null;
let _loading = false;
let _allQuestionsAnswered = false;

const CHANGE_EVENT = 'change'; // globālais

const QuestionStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
	* @param {function} callback
	*/
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },


  addQuestion(question) {
    if (!_questions[question._id]) {
      _questions[question._id] = {};
    }

    // default vērtības
    const questionDefault = {
      _id: null,
    };

    _questions[question._id] = _.assign(questionDefault, question);
    _lastQuestionId = question._id;
    _lastQuestionSaved = false;
    _lastQuestionSkipped = false;
  },

  getLast() {
    return _questions[_lastQuestionId];
  },

  /**
	 * @param {boolean} vai pēdējāis jautājums ir saglabāts
	 */
  setLastQuestionSaved(val) {
    _lastQuestionSaved = val;
  },

  /**
	 * @param {boolean} vai pēdējāis jautājums ir izlaists
	 */
  setLastQuestionSkipped(val) {
    _lastQuestionSkipped = val;
  },

  /**
	 * @param {boolean} vai notiek ielādēšana
	 */
  setLoading(val) {
    _loading = val;
  },

  getLoading() {
    return _loading;
  },

  getLastQuestionSaved() {
    return _lastQuestionSaved;
  },

  getLastQuestionSkipped() {
    return _lastQuestionSkipped;
  },

  /**
	 * @param {number} progress procentos
	 */
  setScore(val) {
    _score = val;
  },

  getScore(val) {
    return _score;
  },

  /**
	 * @param {string} pēdējais rīcības tips
	 */
  setLastActionType(val) {
    _lastActionType = val;
  },

  getLastActionType() {
    return _lastActionType;
  },
  setAllQuestionsAnswered(val) {
    return _allQuestionsAnswered = val;
  },
  getAllQuestionsAnswered() {
    return _allQuestionsAnswered;
  },
});

QuestionStore.dispatchToken = AppDispatcher.register((action) => {
  QuestionStore.setLastActionType(action.type);
  if (
    action.type == ActionTypes.QUESTION_LOAD_SUCCESS ||
		action.type == ActionTypes.QUESTION_LOAD_FAIL
  ) {
    QuestionStore.setLoading(false);
    if (action.question) {
      QuestionStore.setAllQuestionsAnswered(false);
      QuestionStore.addQuestion(action.question);
    } else {
      QuestionStore.setAllQuestionsAnswered(true);
      QuestionStore.addQuestion({ _id: null });
    }
    if (action.score) {
      QuestionStore.setScore(action.score);
    }
    QuestionStore.emitChange();
  } else if (
    action.type == ActionTypes.QUESTION_SKIP_FAIL ||
			action.type == ActionTypes.QUESTION_SKIP_SUCCESS
  ) {
    if (action.type == ActionTypes.QUESTION_SKIP_SUCCESS) {
      QuestionStore.setLastQuestionSkipped(true);
    }
    QuestionStore.emitChange();
  } else if (
    action.type == ActionTypes.ANSWER_SAVE ||
		action.type == ActionTypes.QUESTION_SKIP
  ) {
    QuestionStore.setLoading(true);
    QuestionStore.emitChange();
  } else if (
    action.type == ActionTypes.ANSWER_SAVE_SUCCESS ||
			action.type == ActionTypes.ANSWER_SAVE_FAIL
  ) {
    if (action.type == ActionTypes.ANSWER_SAVE_SUCCESS) {
      QuestionStore.setLastQuestionSaved(true);
    }
    QuestionStore.emitChange();
  } else if (
    (action.type == ActionTypes.ANSWER_SAVE_FAIL) ||
			(action.type == ActionTypes.ANSWER_LOAD_FAIL)
  ) {
    QuestionStore.setLoading(false);
    QuestionStore.emitChange();
  }
});

module.exports = QuestionStore;
